export function throttle(method, time = 200) {
  clearTimeout(method.tId);
  method.tId = setTimeout(function() {
    method();
    method.tId = null;
  }, time);
}